export default "__VITE_ASSET__DZAwHAWN__"